module.exports = _.difference;